import { render, staticRenderFns } from "./ProjectEditDiariesTab.vue?vue&type=template&id=1571e010"
import script from "./ProjectEditDiariesTab.vue?vue&type=script&lang=ts"
export * from "./ProjectEditDiariesTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports